webpackJsonp([137591856104208],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/circleci/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/circleci/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/circleci/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/home/circleci/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/circleci/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/circleci/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/product.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var ProductTemplate = function (_React$Component) {
	  _inherits(ProductTemplate, _React$Component);
	
	  function ProductTemplate() {
	    _classCallCheck(this, ProductTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProductTemplate.prototype.render = function render() {
	    var product = this.props.data.contentfulProduct;
	    var productName = product.productName.productName,
	        productDescription = product.productDescription,
	        price = product.price,
	        image = product.image,
	        brand = product.brand,
	        categories = product.categories;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          style: {
	            display: "flex",
	            alignItems: "center"
	          }
	        },
	        _react2.default.createElement("img", {
	          style: {
	            height: image[0].responsiveResolution.height,
	            width: image[0].responsiveResolution.width
	          },
	          src: image[0].responsiveResolution.src,
	          srcSet: image[0].responsiveResolution.srcSet
	        }),
	        _react2.default.createElement(
	          "h4",
	          null,
	          productName
	        )
	      ),
	      _react2.default.createElement(
	        "h1",
	        null,
	        productName
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Made by ",
	        brand.companyName.companyName
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          null,
	          "Price: $",
	          price
	        ),
	        _react2.default.createElement("div", {
	          dangerouslySetInnerHTML: {
	            __html: productDescription.childMarkdownRemark.html
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            "See other: "
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            categories.map(function (category, i) {
	              return _react2.default.createElement(
	                "li",
	                { key: i },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { key: i, to: "/categories/" + category.id },
	                  category.title.title
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ProductTemplate;
	}(_react2.default.Component);
	
	ProductTemplate.propTypes = propTypes;
	
	exports.default = ProductTemplate;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-js-77a2e9c60ee81f9d0012.js